// Helpers de "tipos de servicio" (tiers: Básico, Premium, …) compartidos entre
// la app móvil y el panel de administración web.
//
// En este producto el CONDUCTOR no elige su tier: se registra igual que siempre
// y es la administración web quien clasifica cada vehículo escribiendo
// `carTypes` (arreglo de nombres de tier) en `cars/<id>` y en `users/<uid>`.
// La app móvil sólo LEE ese campo para emparejar solicitudes.

// Normaliza un valor a arreglo no vacío de strings, o `null`.
export const normalizeCarTypes = value =>
  Array.isArray(value) && value.filter(Boolean).length > 0
    ? value.filter(Boolean)
    : null;

// Deriva el `carType` legacy (string único) a partir del primer tier.
export const deriveCarType = (carTypes, fallback) => {
  const list = normalizeCarTypes(carTypes);
  return list ? list[0] : fallback || 'Taxi';
};

// ¿El conductor atiende el tier `typeName` (p. ej. "Premium")?
//  - `driver.carTypes` (arreglo) es la fuente de verdad cuando la administración
//    ya clasificó el vehículo. Match exacto y sensible a mayúsculas/acentos.
//  - Si `carTypes` viene vacío/ausente (vehículos aún sin clasificar) se asume
//    que atiende TODOS los tiers, para no dejar conductores sin viajes.
export const driverServesCarType = (driver, typeName) => {
  if (!driver || !typeName) return true;
  const served = normalizeCarTypes(driver.carTypes);
  if (served) return served.includes(typeName);
  return true;
};
